

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$TokenizedWalledLoaderFactory', function () {
    var goToTokenizationInfoPage = function goToTokenizationInfoPage() {
        _logger.$logger.info('tokenized_wallet', {
            'from': 'PP_AndroidPay_Info',
            'to': 'prepare_PP_AndroidPay_Info',
            'context_id': _angular.$rootScope.token,
            'context_type': 'EC-Token',
            'billing_token': _squid.$meta.baToken
        });
        $('#outerWrapper').addClass('tokenization');
        _uiRouter.$state.go('checkout.tokenizationInfo');
    };

    var getCardLoaderMessage = function getCardLoaderMessage(tokenizedWalletInfoModel) {
        return (0, _squid.$renderContent)('topup.commonAdding', {
            type: tokenizedWalletInfoModel.brandName()
        }).toString();
    };

    return {
        goToTokenizationInfoPage: goToTokenizationInfoPage,
        getCardLoaderMessage: getCardLoaderMessage
    };
});

_uiRouter.$state;

_angular.$rootScope;

_squid.$meta;

_squid.$renderContent;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/tokenized-wallet-loader/factory.js
// module id = ./pages/xo-login/tokenized-wallet-loader/factory.js
// module chunks = 0